
import React from 'react';
import '../App.css';
import { Button } from './Button';
import '../csscontainer/Body.css';
import { TEXT } from "../utility/constants";

function Body() {
  return (
    <div className='hero-container'>
     
      <h1>{TEXT.HOMECAPTION}.</h1>
      <p>{TEXT.HOMESUBCAPTION}</p>
      <div className='hero-btns'>
        <Button
          className='btns'
          buttonStyle='btn--outline'
          buttonSize='btn--large'
        >
          GET STARTED
        </Button>
        <Button
          className='btns'
          buttonStyle='btn--primary'
          buttonSize='btn--large'
          onClick={console.log('hey')}
        >
          Learn More <i className='far fa-play-circle' />
        </Button>
      </div>
    </div>
  );
}

export default Body;
